export enum ScenesView {
  List = 1,
  Map
}

export enum ViewModes {
  User = 1,
  Public
}

export type FnToggleScenesView = () => void;

export type ScenesViewProps = {
  toggleScenesView: FnToggleScenesView;
}
